export enum VolleyballRefereeChallengeAttribute {
  CallStands = 525,
  CallOverturned = 526,
}
